<template>
<div>
    <button @click="sair" class="btn btn-primary">Sair</button>
    <div class="row linhaAdm">
        <div class="col-sm-6">
            <router-link :to="{name : 'Produtos Admin'}">
                <div class="jumbotron">
                    Produtos
                </div>
            </router-link>
        </div>
        <div class="col-sm-6">
            <router-link :to="{name :'Servicos Admin'}">
                <div class="jumbotron">
                    Serviços
                </div>
            </router-link>
        </div>
        <div class="col-sm-6">
            <router-link :to="{name :'Categorias Prod Admin'}">
                <div class="jumbotron">
                    Categorias de Produtos
                </div>
            </router-link>
        </div>
        <div class="col-sm-6">
            <router-link :to="{name :'Categorias Serv Admin'}">
                <div class="jumbotron">
                    Categorias de Servicos
                </div>
            </router-link>
        </div>
    </div>
</div>
    
</template>
<script>
import firebase from 'firebase';

export default {
    methods: {
        sair() {
            firebase.auth().signOut()
        }
    }
}
</script>
<style>
.linhaAdm {
    text-align: center;
    margin-top: 7%
}
</style>

